<template>
    <div v-if="ready" class="bg-white">
        <MenuOctolo :logo="logo">
            <menu-home :isHabitat="isHabitat" />
        </MenuOctolo>
        <router-view />
    </div>
    <footer-octolo />
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
    name: 'request-contact',
    data(){ return {
        logo_default: "/static/img/LOGO-OCTOLO-H-NEW.svg",
        logo_habitat: "/static/img/habitat/LOGO-OCTOLO-HABITAT-NEW.svg",
        submit: 0,
        errorValue: false,
        errorMessage: null,
        modals: {
            valid: false,
        },
        fs: {},
    }},
    components: {
        MenuOctolo: defineAsyncComponent(() => import("@/toremove/components/menu/Menu.vue")),
        FooterOctolo: defineAsyncComponent(() => import("@/toremove/components/octolo/utils/Footer.vue")),
        MenuHome: defineAsyncComponent(() => import("@/pages/contact/utils/Menu.vue")),
    },
    computed: {
        logo(){
            return this.isHabitat ? this.logo_habitat : this.logo_default;
        },
        landing(){
            return this.$route.params.landing;
        },
        isHabitat(){
            return (this.landing == "habitat");
        },
    },
    async mounted() {
        await this.loadTranslate();
        await this.loadConfig();
        if ((import.meta.env.PROD) || (process.env.ENABLE_SENTRY)) {
            this.$sentry.getCurrentScope().addEventProcessor(event => {
                event.release = this.$store.getters['User/getRelease'];
                return event;
            });
        }
        this.ready = true;
    },
}
</script>

<style lang="scss">
@import "@/assets/octolo.scss";
</style>
